// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"132":"plyr","374":"PhotoSwipeUI","754":"@glidejs/glide","799":"photoswipe"}[chunkId] + ".chunk.js";
};